/* eslint-disable no-console */
import { SwishError } from '../errors';

export const handleError = ( error: SwishError ) => {
  console.error( 'statusCode:', error.statusCode );
  console.error( 'name:', error.name );
  console.error( 'message:', error.message );
};
